import React, { useState, useEffect, useContext, useRef } from 'react';
import TitleBar from '../components/TitleBar.jsx';
import { urlValue, loadingContext, unfolder, openAlert, closeModalVw, openModalVw, useTranslate, encrypter } from '../lib';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form'
import axios from 'axios';
import '../styles/campaign_customizable.css';
import 'react-multi-carousel/lib/styles.css';
import { Tooltip, } from 'react-tooltip'
import { Alerts } from '../components/common/Alerts';
import Loading from '../components/Loading'
import Button from '../components/provider/button/button.jsx'
import { SelectNesting } from '../components/common/Inputs/Select'
import NewCampaingModal from '../components/NewCampaingModal'
import NewSubCampaingModal from '../components/NewSubCampaingModal'
import NewUserStudio from '../components/NewUserStudio'
import DataTable from '../components/provider/datatable/Datatable';
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../components/common/ModalVw'

const Campaigns = () => {
  const { campaign_id, campaign_name } = useParams();
  const [loading, setLoading] = useContext(loadingContext);
  const [region, setRegion] = useState([])
  const [campaigns, setCampaigns] = useState([])
  const [campaign, setCampaign] = useState([])
  const [subCampaign, setSubCampaign] = useState([])
  const [lobs, setLobs] = useState([])
  const [alert, setAlert] = useState({ title: '', visible: false });
  const [users, setUsers] = useState([])
  const [loadingUpload, setLoadingUpload] = useState(false)
  const [role, setRole] = useState(0)
  const users_ref = useRef(null)
  const lobs_ref = useRef(null)  
  const { t } = useTranslate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()

  const [isModalCampOpen, setIsModalCampOpen] = useState({
    cam: false,
    campaing: null,
    error: false,
    newCampaing: false,
    drop: false,
    edit: false,
  })
  const [isModalOpen, setIsModalOpen] = useState({
    error: false,
    newCampaing: false,
    newSubCampaing: false,
    drop: false,
    edit: false,
  })
  const [isModalOpenUserStudio, setIsModalOpenUserStudio] = useState({
    delete: false,
    new: false,
    edit: false,
    delete_many: false
  })

  const columnsUsers = [
    {
      header: 'NT User',
      field: 'ccms_name',
      width: '50%',
    },
    {
      header: 'BMS',
      field: 'ccms_id',
      width: '30%',
      align: 'left',
      render: (value) => <div style={{fontSize: 12}}>{value}</div>
    }
  ];

  const columnsLobs = [
    {
      header: 'Name',
      field: 'name',
      width: '100%',
    },
    {
      header: 'Actions',
      field: 'actions',
      width: '20%',
      align: 'center',
      render: (_, lob) => (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
          <img
            src="/icons/edit.png"
            alt="edit"
            style={{ width: 15, cursor: 'pointer' }}
            // onClick={() => openModal('edit', client)}
          />
          <img
            src="/icons/trash.png"
            alt="trash"
            style={{ width: 15, cursor: 'pointer' }}
            // onClick={() => openModal('delete', client)}
          />
          <img
            src="/icons/chevron-right.svg"
            alt="trash"
            style={{ width: 9, cursor: 'pointer' }}
            onClick={() => getUserLobs(lob)}
          />
        </div>
      )
    }
  ];

  const getUserLobs = async (lob) => {
    console.log("getUserLobs", lob)
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    setSubCampaign(lob.id)
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/campaign/${lob.campaign_id}/lob/${lob.id}`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        }
      });

      if (rest.status === 200 && rest.data) {
        setUsers(rest.data)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  useEffect(() => {
    (async () => {
      setRole(unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role)
      await fetchRegion();
      
    })()

  }, []);

  const getCampaigns = async (region_id) => {
    console.log("region", region_id)
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/campaign/${id}`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
          'region_id': region_id
        }
      });

      if (rest.status === 200 && rest.data) {
        setCampaigns(rest.data)
        await getLobs(rest.data[0].id)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const getLobs = async (campaign_id) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/campaign/lobs/${campaign_id}`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        }
      });

      if (rest.status === 200 && rest.data) {
        setLobs(rest.data)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }
  
  const fetchRegion = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/campaign/regions`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setRegion(rest.data)
        setCampaign(rest.data[0].id)
        await getCampaigns(rest.data[0].id)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  return (
    <>
      <div className="container-home general-container d-flex flex-row justify-space-center" id="container-home">
        <div className="d-flex flex-column" style={{ flex: 1 }}>
          <TitleBar />

          <div>
            <h1 style={{ color: "#0087ff", fontWeight: "bold" }}>Campaigns</h1>
          </div>

          <div className='d-flex flex-row flex-wrap justify-content-between mt-3'>
            <div className='tooltip-div'>
              <img id="campaing-tp" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting  " alt="" />
              <Button 
                label={t('menu.newCampaign')}
                onClick={() => openModalVw("#newcp-modal", () => setIsModalCampOpen({ ...isModalCampOpen, cam: true }))}
                className='buttonE'
                style={{marginRight: '15px'}}
              />
              {/*
              <button onClick={() => openModalVw("#newcp-modal", () => setIsModalCampOpen({ ...isModalCampOpen, cam: true }))}
                className='button-setup   camp-btn' type="button" style={{ borderRadius: 20, backgroundColor: '#0038A8' }}
              >{t('menu.newCampaign')}</button>
              */}
              <Tooltip events={['click']} anchorId="campaing-tp" 
                html={t('menu.newcampaignTooltip')} place="top" />
              <SelectNesting
                id="region_select"
                boxInfo={false} tooltipText= "Here you can select region "
                title="Select Region:"
                onChange={(e) => {
                  getCampaigns(e.target.value)
                }}
                style={{marginRight: '15px'}}
              >
                {region?.map((item, index) => (<option key={`region ${index + 1}:`} value={item.id}>{item.name}</option>))}
              </SelectNesting>
              <SelectNesting
                id="campaign_select"
                boxInfo={false} tooltipText= "Here you can select Campaign"
                title="Select Campaign:"
                onChange={(e) => {
                  setCampaign(e.target.value)
                  getLobs(e.target.value)
                }}
              >
                {campaigns?.map((item, index) => (<option key={`campaign ${index + 1}:`} value={item.id}>{item.name}</option>))}
              </SelectNesting>
            </div>
            

          </div>

          <div className="d-flex flex-row flex-wrap mt-1" style={{}}>
            <div className='left-home panel-left panel-c ' style={{ overflowY: "hidden", height: "auto", flex: '1 1 auto' }}>

              <div className="d-flex flex-row align-items-center justify-space-between " style={{ marginBottom: 15 }}>
                <div className="d-flex flex-row align-items-center">
                  <div className='tooltip-div' style={{ marginLeft: 12 }}>
                    <img id="sub-campaing-tp" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting  " alt="" />
                    <Button 
                      label={t('menu.newLOB')}
                      onClick={() => openModalVw("#sbnewcp-modal", () => setIsModalOpen({ ...isModalOpen, newSubCampaing: true }))}
                      className='buttonF' id="btn-sub-campaign"
                    >
                      {t('menu.newLOB')}
                    </Button>
                    <Tooltip events={['click']} anchorId="sub-campaing-tp" 
                      html={t('menu.newSubcampaignTooltip')} place="top" />
                  </div>
                </div>

              </div>


              <div className='list-l-nesting'>
                <DataTable
                  columns={columnsLobs}
                  data={lobs}
                  tableRef={lobs_ref}
                  tableId="usersCampaign-all"
                  keyField="id"
                  emptyMessage="Lobs not found"
                  tableStyles={{ 
                    borderRadius: '8px',
                    overflow: 'hidden',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                  }}
                  headerStyles={{
                    backgroundColor: '#f5f5f5',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}
                  rowStyles={{
                    transition: 'background-color 0.2s'
                  }}
                />
              </div>
            </div>
            <div className='rigth-home panel-c' style={{ overflowY: "hidden", overflowX: 'clip', height: "auto", flex: '1 1 auto' }}>
              <div className="d-flex flex-row align-items-center justify-space-between" style={{ marginBottom: 15 }}>
                <div className="ml-3 d-flex flex-row align-items-center">
                </div>

              </div>

              <div id="project-all  " className='list-r-nesting'>
                <div className="d-flex flex-row align-items-center justify-space-between " style={{ marginBottom: 15 }}>
                  <div className="d-flex flex-row align-items-center">
                    <div className='tooltip-div' style={{ marginLeft: 12 }}>
                      <img id="sub-campaing-tp" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting  " alt="" />
                      <Button 
                        label={t('menu.addUser')}
                        onClick={() => openModalVw("#adduser-studio", () => setIsModalOpenUserStudio({ ...isModalOpenUserStudio, new: true }))}
                        className='buttonF' id="btn-sub-campaign"
                      >
                        {t('menu.addUser')}
                      </Button>
                      <Tooltip events={['click']} anchorId="sub-campaing-tp" 
                        html={t('menu.selectCampaign')} place="top" />
                    </div>
                  </div>

                </div>
                <DataTable
                    columns={columnsUsers}
                    data={users}
                    tableRef={users_ref}
                    tableId="usersCampaign-all"
                    keyField="id"
                    emptyMessage={t('menu.usersNotFound')}
                    tableStyles={{ 
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}
                    headerStyles={{
                      backgroundColor: '#f5f5f5',
                      fontWeight: 'bold',
                      fontSize: '14px'
                    }}
                    rowStyles={{
                      transition: 'background-color 0.2s'
                    }}
                  />
                {/* {users
                  .map((item, i) => (
                  <div key={i} className='project-cont flex items-center' style={{ position: 'relative' }}>
                    <span className='flex items-center' style={{ flex: 1 }}><p>{item.name}</p>  </span>
                    <Tooltip anchorId={"setupp" + i} content={t('menu.goToProjectSettings')} place="top" />
                  </div>
                ))} */}
              </div>
            </div>

          </div>
          {/* <div className=" d-flex flex-row flex-wrap justify-space-between w-100 mt-1" style={{ display: "none", overflowY: "scroll", overflowX: "hidden" }}>
            {false && projects
              .filter(value => {
                if (searchProjects == '') {
                  return value
                } else if (value.name.toLowerCase().includes(searchProjects.toLowerCase())) {
                  return value
                }
              })
              .map(({ id, name, metadata }, index) => (
                <div
                  className="pl-1 pr-1 pt-1 pb-1 mt-1 d-flex flex-row align-items-center justify-space-between"
                  style={{ overflowX: "hidden", backgroundColor: "rgb(239 239 239)", borderRadius: 5, margin: 2, width: '47%', minWidth: 290 }}
                  key={index}
                  onMouseEnter={() => setAbout(metadata.description)}
                >
                  <div className="d-flex flex-row align-items-center" style={{ overflowX: 'hidden', flex: 1 }}>
                    <span style={{ fontSize: 20, fontWeight: 800, color: "#545454" }}>{name} </span>
                    <span className="ml-2 mr-2" style={{ fontSize: 25, color: "#545454" }}>|</span>
                    <div className="w-100" style={{ letterSpacing: 1, wordWrap: 'break-word', overflowX: 'hidden', fontSize: 14, fontWeight: 600, color: "#727272", whiteSpace: "normal" }}>
                      {metadata.description}
                    </div>
                  </div>
                  <button onClick={() => handleOpen(id)} className="button ml-1" style={{ cursor: 'pointer', border: 'none' }}>
                    <span className="material-icons" style={{ color: "#0087ff", fontSize: 26 }}>delete_outline</span>
                  </button>
                  <span style={{ display: 'none' }}>{name}</span>
                  <button onClick={handleNavigate} className="pl-3 pr-3 pt-1 pb-1 ml-1 "
                    style={{ borderRadius: 15, border: "1px solid #0087ff", color: "#0087ff", fontSize: 16, fontWeight: 700, cursor: 'pointer' }}>
                    Setup
                  </button>
                </div>
              ))}
          </div> */}
        </div>
        {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
      </div>

      {isModalCampOpen.cam &&
      <ModalVw id="newcp-modal" visible={isModalCampOpen.cam}  >
        <ModalContent clases={`bg-white`}>
          <ModalHeader iconClose={true} title="" onClose={() => closeModalVw("#newcp-modal", () => setIsModalCampOpen({ ...isModalCampOpen, cam: false }))} />
          <ModalBody clases={``} >
            <NewCampaingModal isModalOpen={isModalCampOpen} closeModal={() => closeModalVw("#newcp-modal", () => setIsModalCampOpen({ ...isModalCampOpen, cam: false }))} />
          </ModalBody>
        </ModalContent>
      </ModalVw>}

      {isModalOpen.newSubCampaing &&
        <ModalVw id="sbnewcp-modal" visible={isModalOpen.newSubCampaing}  >
          <ModalContent clases={`bg-white`}>
            <ModalHeader iconClose={true} title="" onClose={() => closeModalVw("#sbnewcp-modal", () => setIsModalOpen({ ...isModalOpen, newSubCampaing: false }))} />
            <ModalBody clases={``} >
              <NewSubCampaingModal campaign_id={campaign} isModalOpen={isModalOpen} closeModal={() => { closeModalVw("#sbnewcp-modal", () => setIsModalOpen({ ...isModalOpen, newSubCampaing: false })) }} />
            </ModalBody>
          </ModalContent>
        </ModalVw>}

        {isModalOpenUserStudio.new &&
          <ModalVw id="adduser-studio" visible={isModalOpenUserStudio.new} className="z-[500]">
            <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
              <ModalHeader title="" onClose={() => closeModalVw("#adduser-studio", () => setIsModalOpenUserStudio({ ...isModalOpen, new: false }))} />
              <ModalBody clases={``} >
                <NewUserStudio isModalOpen={isModalOpenUserStudio} 
                  closeModal={() => { closeModalVw("#adduser-studio", () => setIsModalOpen({ ...isModalOpenUserStudio, new: false })) }} 
                  campaign_id={campaign}
                  sub_campaing_id={subCampaign}
                />
              </ModalBody>
            </ModalContent>
        </ModalVw>
      }
     
    </>
  );
};

export default Campaigns;
